import superagent from "superagent";
import { API_V2_URL } from "./base";

export function getTakeAwaySlots(venueId, latitude, longitude) {
  const URL = `${API_V2_URL}venues/${venueId}/available_take_away_slots`;
  const time = new Date();

  return new Promise((resolve, reject) => {
    superagent
      .get(URL)
      .query({latitude: latitude, longitude: longitude, time: time})
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}
